module.exports = __webpack_public_path__ + "img/solution_icon3.4bb911d0.png";